import React from "react";
import { FaCircle } from 'react-icons/fa';

import styles from "./player-level.module.scss";
import PropTypes from "prop-types";

const PlayerLevel = () => {
  return (
    <div className={styles.root}>
      <div>Schwierigkeit:</div>
      <div className={styles.level}>
        <FaCircle size={10} color={"#008000"} /> <span>Einfach </span>
      </div>
      <div className={styles.level}>
        <FaCircle size={10} color={"#ffa500"} /> <span>Mittel </span>
      </div>
      <div className={styles.level}>
        <FaCircle size={10} color={"#ff0000"} /> <span>Schwer </span>
      </div>
    </div>
  );
};

PlayerLevel.defaultProps = {};

PlayerLevel.propTypes = {
  coverImgUrl: PropTypes.string,
};

export default PlayerLevel;
